import React, {useEffect, useState} from 'react';
import useOutsideClick from '@/hooks/use-outside-click/use-outside-click';
import ActionText from '@/atoms/ActionText/ActionText';
import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import Icon from '@/atoms/Icon/Icon';
import StyledFilterDropdown, {
  StyledFilterDropdownHeader,
  StyledFilterDropdownBody,
  StyledFilterDropdownFooter,
  StyledFilterDropdownButton,
  StyledFilterDropdownContainer,
} from './styles';
import Props from './typings';
import colors from '@/theme/constants/colors';

const FilterDropdown = ({
  defaultTitle,
  title,
  header,
  resultCount,
  hasErrors,
  searchFn,
  clearFn,
  children,
  onOpen,
  dropdownPosition = 'left',
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownWidth = 430;

  const toggleState = () => {
    setIsOpen(!isOpen);
  };
  const closeDropdown = () => setIsOpen(false);

  const dropdownRef = useOutsideClick(closeDropdown, isOpen);

  const searchClick = () => {
    searchFn();
    closeDropdown();
  };

  const clearClick = () => {
    clearFn();
    closeDropdown();
  };

  const artworkCount = (number) => {
    if (number > 1000) return '1000+';
    return number;
  };

  useEffect(() => {
    if (onOpen) onOpen(isOpen);
  }, [isOpen]);

  const calculateDropdownPosition = () => {
    const position =
      window.innerWidth - dropdownRef.current.getBoundingClientRect().x < dropdownWidth
        ? 'right'
        : 'left';
    return position;
  };

  return (
    <StyledFilterDropdownContainer ref={dropdownRef}>
      <StyledFilterDropdownButton
        $isOpen={isOpen}
        $count={title?.count ?? 0}
        $showCount={
          (title?.count > 0 && !title?.label.length) ||
          (title?.count > 1 && title?.label.length > 0)
        }
        onClick={toggleState}
      >
        <span>{title?.label?.length > 0 ? title.label[0] : defaultTitle}</span>
      </StyledFilterDropdownButton>

      {isOpen && (
        <StyledFilterDropdown
          $position={dropdownPosition === 'auto' ? calculateDropdownPosition() : dropdownPosition}
        >
          {header && (
            <StyledFilterDropdownHeader>
              <button onClick={toggleState}>
                <Icon type="arrow-left" color={colors.darkBlue100} fontSize={12} />
              </button>

              <h6>{header}</h6>

              <ActionText fontSize={12} onClick={clearClick}>
                Clear all
              </ActionText>
            </StyledFilterDropdownHeader>
          )}

          <StyledFilterDropdownBody $hasHeader={!!header}>{children}</StyledFilterDropdownBody>

          <StyledFilterDropdownFooter>
            <ActionText fontSize={12} onClick={clearClick}>
              Clear
            </ActionText>

            <CtaButton onClick={searchClick} disabled={hasErrors}>
              {`See ${artworkCount(resultCount)} ${resultCount === 1 ? 'artwork' : 'artworks'}`}
            </CtaButton>
          </StyledFilterDropdownFooter>
        </StyledFilterDropdown>
      )}
    </StyledFilterDropdownContainer>
  );
};

export default FilterDropdown;
